// Angular
import { Component, OnInit } from '@angular/core';
// Models
// Services

import { ApiService } from './../../services/api';
import * as lodash from 'lodash';
import { OAuthService } from './../../services/o-auth';
import { Club } from './../../models/club'
import { AngularFireDatabase } from 'angularfire2/database';
import { Http } from '@angular/http';
import { ActivatedRoute } from '@angular/router';

@Component({
    templateUrl: './course.component.html'
})
export class CourseComponent implements OnInit {
    public club: Club;
    public clubId:string
    public courseCount: number;
    public courses: Array<any>;
    public imageLoader: boolean = true;
    public course: any;
    constructor(private apiService: ApiService,private route: ActivatedRoute, private oAuthService: OAuthService, private fireDatabase: AngularFireDatabase, private http: Http) {
        this.clubId = this.route.snapshot.params['id'];
        this.course = {
            name: '',
            holes: 9,
            $key: ''
        }

    }



    ngOnInit() {
this.fireDatabase.object("users/"+this.clubId).subscribe((result)=>{
    this.club=result
    this.initData()

})
    }


    public submit() {
        // console.log(this.courseCount)
        if(this.course.name !=""){
            if (this.courseCount == undefined) {
                this.courseCount = 0;
            }
            this.courseCount++;
            const id = this.club.$key + '-0' + this.courseCount;
            // console.log(this.course)
            // console.log(id)
            this.course.holes = parseInt(this.course.holes)
            delete this.course.$key
    
            this.fireDatabase.database.ref(`/users/${this.club.$key}/courses/${id}/`)
                .set(this.course)
                .then(postResult => {
                    this.initData();
                    $('#myCourseModal').modal('hide');
                    this.course = {};
                })
                .catch(error => {
                    // console.log(error);
                });
        }
       

    }
    public getType(event) {
        // console.log(event);
        this.course.holes = event
    }
    initData() {
        if (this.club.courses) {
            // console.log(this.club)
            this.courseCount = 0;
            this.courses = [];

            lodash.forEach(this.club.courses, (item: any, key) => {
                this.courseCount++;
                const course = {
                    name: item.name,
                    holes: item.holes,
                    $key: key,
                    tees: []
                };

                lodash.forEach(item.tees, (tee: any, key1) => {
                    course.tees.push({
                        name: tee.name,
                        color: tee.color,
                        $key: key1
                    });
                });

                this.courses.push(course);
            });
            this.imageLoader = false;
        }
        this.imageLoader = false;



    }
   


}
